import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "../../store"
import { values, filter } from "lodash"

export const getOrgRoles = createSelector(
  (state: RootState) => state.roles.byIds,
  (state: RootState, orgId: string) => orgId,
  (rolesById, orgId) => filter(values(rolesById), { orgId })
)
